(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dm-amazon"] && !Shopify.designMode) return;
  try {
    
(function(){
  if(window.__dmRev)return;window.__dmRev=1;
  var rm=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;
  var els=function(){return document.querySelectorAll('[data-dm-reveal]:not(.dm-in)');};
  if(rm||!('IntersectionObserver'in window)){els().forEach(function(e){e.classList.add('dm-in');});return;}
  var io=new IntersectionObserver(function(en){en.forEach(function(x){if(x.isIntersecting){x.target.classList.add('dm-in');io.unobserve(x.target);}});},{threshold:.12,rootMargin:'0px 0px -8% 0px'});
  var scan=function(){els().forEach(function(e){io.observe(e);});};scan();
  document.addEventListener('shopify:section:load',scan);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dm-announcement"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('[data-dm-cd]').forEach(function(el){
    var end=new Date(el.getAttribute('data-dm-cd')).getTime();
    if(isNaN(end)){var s=el.closest('span'); if(s)s.style.display='none'; return;}
    function pad(n){return(n<10?'0':'')+n;}
    function tick(){var s=Math.max(0,Math.floor((end-Date.now())/1000));var d=Math.floor(s/86400);s-=d*86400;var h=Math.floor(s/3600);s-=h*3600;var m=Math.floor(s/60);var ss=s-m*60;el.textContent=(d>0?d+'d ':'')+(d>0?pad(h):h)+'h '+pad(m)+'m '+pad(ss)+'s';}
    tick(); setInterval(tick,1000);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dm-apply"] && !Shopify.designMode) return;
  try {
    
(function(){
  if(window.location.hash==='#contact_form'||window.location.search.indexOf('form_type=contact')>-1){
    var ok=document.querySelector('.dm-ap-ok,.dm-ap-err');
    if(ok)ok.scrollIntoView({behavior:'smooth',block:'center'});
  }
  if(window.__dmRev)return;window.__dmRev=1;
  var rm=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;
  var els=function(){return document.querySelectorAll('[data-dm-reveal]:not(.dm-in)');};
  if(rm||!('IntersectionObserver'in window)){els().forEach(function(e){e.classList.add('dm-in');});return;}
  var io=new IntersectionObserver(function(en){en.forEach(function(x){if(x.isIntersecting){x.target.classList.add('dm-in');io.unobserve(x.target);}});},{threshold:.12,rootMargin:'0px 0px -8% 0px'});
  var scan=function(){els().forEach(function(e){io.observe(e);});};scan();
  document.addEventListener('shopify:section:load',scan);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dm-articles"] && !Shopify.designMode) return;
  try {
    
(function(){if(window.__dmRev)return;window.__dmRev=1;var rm=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;var els=function(){return document.querySelectorAll('[data-dm-reveal]:not(.dm-in)');};if(rm||!('IntersectionObserver'in window)){els().forEach(function(e){e.classList.add('dm-in');});return;}var io=new IntersectionObserver(function(en){en.forEach(function(x){if(x.isIntersecting){x.target.classList.add('dm-in');io.unobserve(x.target);}});},{threshold:.12,rootMargin:'0px 0px -8% 0px'});var scan=function(){els().forEach(function(e){io.observe(e);});};scan();document.addEventListener('shopify:section:load',scan);})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dm-bestsellers"] && !Shopify.designMode) return;
  try {
    
(function(){if(window.__dmRev)return;window.__dmRev=1;var rm=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;var els=function(){return document.querySelectorAll('[data-dm-reveal]:not(.dm-in)');};if(rm||!('IntersectionObserver'in window)){els().forEach(function(e){e.classList.add('dm-in');});return;}var io=new IntersectionObserver(function(en){en.forEach(function(x){if(x.isIntersecting){x.target.classList.add('dm-in');io.unobserve(x.target);}});},{threshold:.12,rootMargin:'0px 0px -8% 0px'});var scan=function(){els().forEach(function(e){io.observe(e);});};scan();document.addEventListener('shopify:section:load',scan);})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dm-community"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('[data-dm-rail]').forEach(function(w){var rail=w.querySelector('.dm-rail');if(!rail)return;var nx=w.querySelector('[data-dm-rail-btn="next"]'),pv=w.querySelector('[data-dm-rail-btn="prev"]');if(nx)nx.addEventListener('click',function(){rail.scrollBy({left:332,behavior:'smooth'});});if(pv)pv.addEventListener('click',function(){rail.scrollBy({left:-332,behavior:'smooth'});});});
  if(window.__dmRev)return;window.__dmRev=1;var rm=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;var els=function(){return document.querySelectorAll('[data-dm-reveal]:not(.dm-in)');};if(rm||!('IntersectionObserver'in window)){els().forEach(function(e){e.classList.add('dm-in');});return;}var io=new IntersectionObserver(function(en){en.forEach(function(x){if(x.isIntersecting){x.target.classList.add('dm-in');io.unobserve(x.target);}});},{threshold:.12,rootMargin:'0px 0px -8% 0px'});var scan=function(){els().forEach(function(e){io.observe(e);});};scan();document.addEventListener('shopify:section:load',scan);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dm-creator"] && !Shopify.designMode) return;
  try {
    
(function(){
  if(window.__dmRev)return;window.__dmRev=1;
  var rm=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;
  var els=function(){return document.querySelectorAll('[data-dm-reveal]:not(.dm-in)');};
  if(rm||!('IntersectionObserver'in window)){els().forEach(function(e){e.classList.add('dm-in');});return;}
  var io=new IntersectionObserver(function(en){en.forEach(function(x){if(x.isIntersecting){x.target.classList.add('dm-in');io.unobserve(x.target);}});},{threshold:.12,rootMargin:'0px 0px -8% 0px'});
  var scan=function(){els().forEach(function(e){io.observe(e);});};scan();
  document.addEventListener('shopify:section:load',scan);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dm-faq"] && !Shopify.designMode) return;
  try {
    
(function(){if(window.__dmRev)return;window.__dmRev=1;var rm=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;var els=function(){return document.querySelectorAll('[data-dm-reveal]:not(.dm-in)');};if(rm||!('IntersectionObserver'in window)){els().forEach(function(e){e.classList.add('dm-in');});return;}var io=new IntersectionObserver(function(en){en.forEach(function(x){if(x.isIntersecting){x.target.classList.add('dm-in');io.unobserve(x.target);}});},{threshold:.12,rootMargin:'0px 0px -8% 0px'});var scan=function(){els().forEach(function(e){io.observe(e);});};scan();document.addEventListener('shopify:section:load',scan);})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dm-featured-product"] && !Shopify.designMode) return;
  try {
    
(function(){if(window.__dmRev)return;window.__dmRev=1;var rm=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;var els=function(){return document.querySelectorAll('[data-dm-reveal]:not(.dm-in)');};if(rm||!('IntersectionObserver'in window)){els().forEach(function(e){e.classList.add('dm-in');});return;}var io=new IntersectionObserver(function(en){en.forEach(function(x){if(x.isIntersecting){x.target.classList.add('dm-in');io.unobserve(x.target);}});},{threshold:.12,rootMargin:'0px 0px -8% 0px'});var scan=function(){els().forEach(function(e){io.observe(e);});};scan();document.addEventListener('shopify:section:load',scan);})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dm-header"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('[data-dm-header]').forEach(function(h){
    var onScroll=function(){h.classList.toggle('dm-stuck',window.scrollY>8);};onScroll();
    window.addEventListener('scroll',onScroll,{passive:true});
    var burger=h.querySelector('[data-dm-burger]'),mob=h.querySelector('[data-dm-mobile]');
    if(burger&&mob){burger.addEventListener('click',function(){var open=mob.hasAttribute('hidden');if(open){mob.removeAttribute('hidden');}else{mob.setAttribute('hidden','');}burger.setAttribute('aria-expanded',open?'true':'false');});}
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dm-hero"] && !Shopify.designMode) return;
  try {
    
(function(){
  var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.querySelectorAll('[data-dm-muse]').forEach(function(hero){
    if(hero.getAttribute('data-dm-muse')==='false'||reduce) return;
    var par=hero.querySelector('[data-dm-par]'), glow=hero.querySelector('[data-dm-glow]'), shop=hero.querySelector('[data-dm-magnetic]');
    var tx=0,ty=0,cx=0,cy=0,bx=0,by=0,bxT=0,byT=0;
    window.addEventListener('mousemove',function(e){
      var dx=e.clientX/window.innerWidth-.5, dy=e.clientY/window.innerHeight-.5; tx=dx*24; ty=dy*15;
      if(glow)glow.style.transform='translate('+(dx*40)+'px,'+(dy*28)+'px)';
      if(shop){var r=shop.getBoundingClientRect(),mx=r.left+r.width/2,my=r.top+r.height/2,ddx=e.clientX-mx,ddy=e.clientY-my,d=Math.hypot(ddx,ddy); if(d<200){bxT=ddx*.25;byT=ddy*.25;}else{bxT=0;byT=0;}}
    });
    (function loop(){ cx+=(tx-cx)*.08; cy+=(ty-cy)*.08; if(par)par.style.transform='translate('+cx+'px,'+cy+'px) rotate('+(cx*.05)+'deg)';
      bx+=(bxT-bx)*.12; by+=(byT-by)*.12; if(shop)shop.style.transform='translate('+bx+'px,'+by+'px)'; requestAnimationFrame(loop); })();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dm-main-product"] && !Shopify.designMode) return;
  try {
    
(function(){
  var main=document.getElementById('dmPdpMain');
  var cur=0;

  document.querySelectorAll('[data-dm-thumbs]').forEach(function(wrap){
    if(!main)return;
    wrap.querySelectorAll('.dm-pdp-thumb').forEach(function(th){th.addEventListener('click',function(){var f=th.getAttribute('data-dm-full');if(f)main.src=f;cur=parseInt(th.getAttribute('data-dm-i'),10)||0;wrap.querySelectorAll('.dm-pdp-thumb').forEach(function(x){x.classList.remove('dm-on');});th.classList.add('dm-on');});});
  });

  var lb=document.querySelector('[data-dm-lb]'),trigger=document.querySelector('[data-dm-zoom]'),srcTag=document.querySelector('[data-dm-zoomsrc]');
  if(!lb||!trigger||!srcTag)return;
  var imgs=[]; try{imgs=JSON.parse(srcTag.textContent)||[];}catch(e){}
  if(!imgs.length)return;
  var lbImg=lb.querySelector('[data-dm-lb-img]'),count=lb.querySelector('[data-dm-lb-count]'),last=null;

  function show(i){
    cur=(i+imgs.length)%imgs.length;
    lbImg.src=imgs[cur];
    if(count)count.textContent=(cur+1)+' / '+imgs.length;
  }
  function open(){
    last=document.activeElement;
    show(cur);
    lb.hidden=false;
    requestAnimationFrame(function(){lb.classList.add('dm-lb-open');});
    document.body.style.overflow='hidden';
    (lb.querySelector('[data-dm-lb-close]')||lb).focus();
  }
  function close(){
    lb.classList.remove('dm-lb-open');
    document.body.style.overflow='';
    setTimeout(function(){lb.hidden=true;},320);
    if(last&&last.focus)last.focus();
  }

  trigger.addEventListener('click',open);
  trigger.addEventListener('keydown',function(e){if(e.key==='Enter'||e.key===' '){e.preventDefault();open();}});
  lb.addEventListener('click',function(e){
    var nav=e.target.closest('[data-dm-lb-nav]');
    if(nav){show(cur+parseInt(nav.getAttribute('data-dm-lb-nav'),10));return;}
    if(e.target.closest('[data-dm-lb-close]')||e.target===lb)close();
  });
  document.addEventListener('keydown',function(e){
    if(lb.hidden)return;
    if(e.key==='Escape')close();
    else if(e.key==='ArrowLeft')show(cur-1);
    else if(e.key==='ArrowRight')show(cur+1);
  });

  var x0=null;
  lb.addEventListener('touchstart',function(e){x0=e.changedTouches[0].clientX;},{passive:true});
  lb.addEventListener('touchend',function(e){
    if(x0===null)return;
    var d=e.changedTouches[0].clientX-x0; x0=null;
    if(Math.abs(d)>45)show(cur+(d<0?1:-1));
  },{passive:true});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dm-manifesto"] && !Shopify.designMode) return;
  try {
    
(function(){
  if(!window.__dmRev){window.__dmRev=1;var rm=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;var els=function(){return document.querySelectorAll('[data-dm-reveal]:not(.dm-in)');};if(rm||!('IntersectionObserver'in window)){els().forEach(function(e){e.classList.add('dm-in');});}else{var io=new IntersectionObserver(function(en){en.forEach(function(x){if(x.isIntersecting){x.target.classList.add('dm-in');io.unobserve(x.target);}});},{threshold:.12,rootMargin:'0px 0px -8% 0px'});var scan=function(){els().forEach(function(e){io.observe(e);});};scan();document.addEventListener('shopify:section:load',scan);}}
  var rm2=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;
  if(!rm2&&'IntersectionObserver'in window){document.querySelectorAll('.dm-mani').forEach(function(sec){var peek=sec.querySelector('[data-dm-peek]');if(!peek)return;var io=new IntersectionObserver(function(en){en.forEach(function(x){peek.classList.toggle('dm-peek-in',x.intersectionRatio>0.25);});},{threshold:[0,.25,.5]});io.observe(sec);});}
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dm-newsletter"] && !Shopify.designMode) return;
  try {
    
(function(){if(window.__dmRev)return;window.__dmRev=1;var rm=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;var els=function(){return document.querySelectorAll('[data-dm-reveal]:not(.dm-in)');};if(rm||!('IntersectionObserver'in window)){els().forEach(function(e){e.classList.add('dm-in');});return;}var io=new IntersectionObserver(function(en){en.forEach(function(x){if(x.isIntersecting){x.target.classList.add('dm-in');io.unobserve(x.target);}});},{threshold:.12,rootMargin:'0px 0px -8% 0px'});var scan=function(){els().forEach(function(e){io.observe(e);});};scan();document.addEventListener('shopify:section:load',scan);})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dm-post-footer"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('[data-dm-pf-form]').forEach(function(form){
    var btn=form.querySelector('[data-dm-pf-add]'),label=form.querySelector('[data-dm-pf-label]');
    var sel=form.querySelector('[data-dm-pf-variant]'),card=form.closest('.dm-pf-body');
    var priceEl=card&&card.querySelector('[data-dm-pf-price]'),wasEl=card&&card.querySelector('[data-dm-pf-was]');

    if(sel&&priceEl){
      sel.addEventListener('change',function(){
        var o=sel.options[sel.selectedIndex];
        if(o.dataset.price)priceEl.textContent=o.dataset.price;
        if(wasEl)wasEl.style.display=(o.dataset.compare&&o.dataset.compare!==o.dataset.price)?'':'none';
      });
    }

    form.addEventListener('submit',function(e){
      if(!window.fetch)return;
      e.preventDefault();
      var prev=label?label.textContent:'';
      if(btn)btn.disabled=true;
      if(label)label.textContent='Adding...';
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({items:[{id:form.querySelector('[name="id"]').value,quantity:1}]})})
      .then(function(r){if(!r.ok)throw new Error('add failed');return r.json();})
      .then(function(){
        if(label)label.textContent='Added to bag';
        if(btn)btn.classList.add('dm-ok');
        return fetch('/cart.js').then(function(r){return r.json();});
      })
      .then(function(cart){
        document.querySelectorAll('[data-dm-cart-count]').forEach(function(n){
          n.textContent=cart.item_count; if(cart.item_count>0)n.removeAttribute('hidden');
        });
        setTimeout(function(){
          if(label)label.textContent=prev;
          if(btn){btn.classList.remove('dm-ok');btn.disabled=false;}
        },2200);
      })
      .catch(function(){ form.submit(); });
    });
  });

  if(window.__dmRev)return;window.__dmRev=1;
  var rm=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;
  var els=function(){return document.querySelectorAll('[data-dm-reveal]:not(.dm-in)');};
  if(rm||!('IntersectionObserver'in window)){els().forEach(function(e){e.classList.add('dm-in');});return;}
  var io=new IntersectionObserver(function(en){en.forEach(function(x){if(x.isIntersecting){x.target.classList.add('dm-in');io.unobserve(x.target);}});},{threshold:.12,rootMargin:'0px 0px -8% 0px'});
  var scan=function(){els().forEach(function(e){io.observe(e);});};scan();
  document.addEventListener('shopify:section:load',scan);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dm-reviews"] && !Shopify.designMode) return;
  try {
    
(function(){if(window.__dmRev)return;window.__dmRev=1;var rm=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;var els=function(){return document.querySelectorAll('[data-dm-reveal]:not(.dm-in)');};if(rm||!('IntersectionObserver'in window)){els().forEach(function(e){e.classList.add('dm-in');});return;}var io=new IntersectionObserver(function(en){en.forEach(function(x){if(x.isIntersecting){x.target.classList.add('dm-in');io.unobserve(x.target);}});},{threshold:.12,rootMargin:'0px 0px -8% 0px'});var scan=function(){els().forEach(function(e){io.observe(e);});};scan();document.addEventListener('shopify:section:load',scan);})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dm-statement"] && !Shopify.designMode) return;
  try {
    
(function(){if(window.__dmRev)return;window.__dmRev=1;var rm=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;
var els=function(){return document.querySelectorAll('[data-dm-reveal]:not(.dm-in)');};
if(rm||!('IntersectionObserver'in window)){els().forEach(function(e){e.classList.add('dm-in');});return;}
var io=new IntersectionObserver(function(en){en.forEach(function(x){if(x.isIntersecting){x.target.classList.add('dm-in');io.unobserve(x.target);}});},{threshold:.12,rootMargin:'0px 0px -8% 0px'});
var scan=function(){els().forEach(function(e){io.observe(e);});};scan();document.addEventListener('shopify:section:load',scan);})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dm-valueprops"] && !Shopify.designMode) return;
  try {
    
(function(){if(window.__dmRev)return;window.__dmRev=1;var rm=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;
var els=function(){return document.querySelectorAll('[data-dm-reveal]:not(.dm-in)');};
if(rm||!('IntersectionObserver'in window)){els().forEach(function(e){e.classList.add('dm-in');});return;}
var io=new IntersectionObserver(function(en){en.forEach(function(x){if(x.isIntersecting){x.target.classList.add('dm-in');io.unobserve(x.target);}});},{threshold:.12,rootMargin:'0px 0px -8% 0px'});
var scan=function(){els().forEach(function(e){io.observe(e);});};scan();document.addEventListener('shopify:section:load',scan);})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
